import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { isEmpty, querySelector } from '@/utils/index';
import styles from './index.module.less';

@inject('area', 'tradeup', 'product', 'app')
class Index extends Component {
  constructor() {
    super();
    this.state = {
      tradeupCache: {},
      visible: false,
    };
  }

  componentDidMount() {
    const { urlQuery } = this.props.app;
    const { productDetail } = this.props.product;
    const { handleTradeupCache } = this.props.tradeup;
    const tradeupCache = handleTradeupCache({ type: 'getCache' }) ?? {};
    if (!isEmpty(urlQuery.source)) {
      this.setState(
        {
          visible: tradeupCache?.pid === productDetail.id,
          tradeupCache,
        },
        async () => {
          this.eleTips = await querySelector('#productTradeUpTips');
          this.eleHeader = await querySelector('#g-header');
          if (this.eleTips && this.eleHeader) {
            this.eleTips.style.top = `${this.eleHeader?.clientHeight}px`;
            document.addEventListener('scroll', this.onScroll);
          }
        }
      );
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.onScroll);
  }

  // 监听下滑事件，在产品详情TopBar\header处产生吸附效果
  onScroll = (e) => {
    const pStickyTabBar = document.getElementById('pProductOverviewMenu');
    const headerHeight = this.eleHeader.clientHeight;
    const scrollHeight = document.scrollingElement.scrollTop;
    const touchTop = scrollHeight > headerHeight;
    if (touchTop) {
      this.eleTips.style.top = `0`;
    } else {
      this.eleTips.style.top = `${headerHeight - scrollHeight}px`;
    }
    if (pStickyTabBar) {
      const pStickyTabBarHide = pStickyTabBar.style.transform.includes('-100%');
      if (!pStickyTabBarHide) {
        this.eleTips.style.top = `${pStickyTabBar.clientHeight}px`;
      }
    }
  };

  render() {
    const { LANG } = this.props.area;
    const { visible, tradeupCache } = this.state;
    if (!visible) return null;
    return (
      <div id='productTradeUpTips' className={styles.tradeupTips}>
        <div className={styles.wrap}>
          {LANG['tradeup.productPageTips'].replace(/(&CAMERA&)|(ONE R)/, tradeupCache?.name)}
          <button className={styles.close} onClick={() => this.setState({ visible: false })}>
            ×
          </button>
        </div>
      </div>
    );
  }
}

export default Index;
